export const ErrorInterceptorSkipHeader = 'X-Skip-Error-Interceptor';
export const TokenInterceptorSkipAccountHeader = 'X-Skip-Token-Interceptor-Account-Id';
export const TokenInterceptorSkipAll = 'X-Skip-Token-Interceptor';
